export const project_statusConstants = {
    GETALL_REQUEST: "GETALL_PROJECT_STATUS_REQUEST",
    GETALL_SUCCESS: "GETALL_PROJECT_STATUS_SUCCESS",
    GETALL_FAILURE: "GETALL_PROJECT_STATUS_FAILURE",
};
